<template lang="pug">
	a.sponsor-banner(
		:href="sponsorLink"
		target="_blank"
		:class="{ fullwidth: fullwidth }"
	)
		img(:src="sponsorProcessedURL")
</template>

<script>
import mediaMixin from '../mixins/mediaMixin'
export default {
	mixins: [mediaMixin],
	props: {
		sponsor: Object,
		sponsorLink: String,
		fullwidth: Boolean
	},
	computed: {
		sponsorThumbnailURL () {
			if (!this.sponsor) {
				return null
			}
			return this.getMediaThumbnailURL(this.sponsor)
		},
		sponsorProcessedURL () {
			if (!this.sponsor) {
				return null
			}
			return this.getMediaProcessedURL(this.sponsor)
		}
	}
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/bulma-variables.scss';
		a.sponsor-banner.fullwidth {
			display: block;
			width: 100%;
			img {
				width: 100%;
			}
		}

</style>
